import React from 'react';

/** True only after mount — keeps SSR / first paint aligned with server HTML. */
const useHydrationSafe = (): boolean => {
    const [isHydrated, setIsHydrated] = React.useState(false);
    React.useEffect(() => {
        setIsHydrated(true);
    }, []);
    return isHydrated;
};

export default useHydrationSafe;
